import controller from './enter-data-controller';
import template from './enter-data.html'

const EnterDataComponent = {
    bindings: {
        clientList: '<',
        facilityFields: '<',
        facilitySettings: '<',
        formMetadata: '<',
        changeReasonList: '<',
        isFormVisible: '<',
        relatedModels: '<',
        savedFormData: '<',
        statToLabelDict: '<',
        lastUpdatedByEmail: '<'
    },
    controller,
    template,
};

export default EnterDataComponent;



// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-component.js